import { Button, Table, Form, Input, Modal, Select, Skeleton, Popconfirm, Row, Col, List, Avatar } from "antd";
import { useEffect, useState } from "react";
import { CheckCircleFilled } from "@ant-design/icons";
import { recordError } from "../../../utils/logService";

import service from "../../../services/citizenscienceService";
import { SearchOutlined } from "@ant-design/icons";
import "../project-join/joinProject.css";

import {
  ContributeModal,
  Messages,
  Notify,
  openNotification,
  paginationEnum,
  SelectedOrganizations,
  util
} from '@seims/shared';

const EditProjectPartners = ({
  partnerData,
  selectedPartners,
  visible,
  onCancel,
  onModalSubmit,
  // newPartners,
  // setNewPartners
}) => {
  const [disabled, setDisabled] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [isNotSearchable, setIsNotSearchable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [partners, setPartners] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showContribModal, setShowContribModal] = useState(false);
  const [displaySelectedOrganisations, setDisplaySelectedOrganisations] =
    useState(false);
  const [previewOrgsContrib, setPreviewOrgsContrib] = useState({});
  const [orgsContributions, setOrgsContributions] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedOrganizations, setSelectedOrganizations] = useState([]);
  const [pageSize, setPageSize] = useState(paginationEnum.DEFAULT_PAGE_SIZE);
  const [total, setTotal] = useState(paginationEnum.DEFAULT_MAX_TOTAL);
  const [currentPage, setCurrentPage] = useState(
    paginationEnum.DEFAULT_FIRST_PAGE
  );
  const [firstRecord, setFirstRecord] = useState(
    paginationEnum.DEFAULT_FIRST_RECORD
  );
  const [pagingDisabled, setPagingDisabled] = useState(false);
  const expectedContributions = ["funding", "host organisation"];

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      defaultSortOrder: "ascend",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      sorter: (a, b) => a.type.localeCompare(b.type),
    },
    {
      title: "Location",
      dataIndex: "address",
      key: "address",
    },
  ];

  let msg = "";
  const [form] = Form.useForm();
  const { Option } = Select;
  const formName = "EditParticipantInfo";

  useEffect(() => {
    getPartners({ first: 0, pageSize: 10 });
  }, [selectedPartners]);

  useEffect(() => {
    autoSelect();
  }, [visible]);

  const autoSelect = () => {
    if (selectedPartners.length > 0) {
      const mergedSelection = [
        ...new Map(
          [...selectedRows, ...selectedPartners].map((item) => [
            item.id,
            item,
            ,
            { newlyAdded: false },
          ])
        ).values(),
      ];

      const newRowsKeys = mergedSelection.map((c) => c.id.toString());

      // setSelectedRowKeys(newRowsKeys);
      // setSelectedRows(mergedSelection);
      // setNewPartners(mergedSelection);
      // setSelectedOrganizations(mergedSelection);
      const updatedPartner = selectedPartners.map((oldPartner) => ({
        ...oldPartner,
        newlyAdded: false,
      }));
      setSelectedOrganizations(updatedPartner);
    }
  };

  const onCancelModal = () => {
    const selectedId = parseInt(selectedRowKeys[0]);
    onRemoveContributions(selectedId);
    setSelectedRowKeys([]);
    setSelectedRows([]);
    onCancel();
  };

  const getPartners = async ({ first = 0, max = 10, searchText = "" }) => {
    const entity = "partners";

    try {
      setLoading(true);
      if (max > total) setTotal(max);
      const response = await service.getOrganizations({
        first: first,
        max: max,
        searchText: searchText,
      });

      if (response) {
        var partnerList = [];
        const { results: data, total } = response?.data;
        const unSelectedPartners = data.filter(
          (c) => !selectedPartners.some((x) => x.id == c.id)
        );

        if (response.status === 204) {
          setFilteredData([]);
          setLoading(false);
          setPagingDisabled(true);

          return;
        }

        partnerList = unSelectedPartners.map((element) => ({
          id: element.id,
          key: element.id.toString(),
          name: element.name,
          type: element.partnerType.value,
          address: `${element.address?.province} (${element.address?.cityOrTown})`,
          typeid: element.partnerType.key,
          partnerAddress: element.address,
          contributions: element.contributions,
          partnerType: element.partnerType,
          email: element.email,
          telephone: element.telephone,
          newlyAdded: true,
        }));
        setFilteredData(partnerList);
        setPartners(partnerList);
        setLoading(false);
        setTotal(total);
        setPagingDisabled(false);
      }
    } catch (error) {
      msg = util.parseMessage(Messages.GET_FAILURE, entity);
      openNotification("Partners", msg, Notify.ERROR);
      recordError(error);
    }
  };

  const handleInputChange = (e) => {
    const { value: searchValue } = e.target;
    setSearchText(searchValue);
    setIsNotSearchable(searchValue === "");

    if (searchValue === "") {
      setFirstRecord(0);
      setCurrentPage(1);
      getPartners({ first: 0, pageSize: 10, searchText: searchValue });
    } else {
      getPartners({ first: 0, pageSize: 10, searchText: searchValue });
    }
  };

  const handleSearchReset = (e) => {
    const { value: searchValue } = e.target;
    setSearchText(searchValue);
    setIsNotSearchable(searchValue === "");

    if (searchValue === "") {
      getPartners({ first: 0, pageSize: 10, searchText: searchValue });
    }
  };

  const handleSearchBtn = () => {
    setFirstRecord(0);
    getPartners({ first: 0, pageSize: 10, searchText: searchText });
  };

  const handleSelectedContributions = (selectedContributions) => {
    // setSelectedData([selectedContributions, ...selectedData]);
    onSelectedOrganization(selectedContributions);
  };

  const onPageChange = (page, total) => {
    const keepCurrentPage = pageSize === total;
    const first = keepCurrentPage ? (page - 1) * pageSize : 0;
    const newPage = keepCurrentPage ? page : 1;

    setFirstRecord(first);
    setPageSize(total);
    setCurrentPage(newPage);
    getPartners({ first: first, max: pageSize, searchText: searchText });
    autoSelect();
  };

  const onShowContributeModal = (value) => {
    setShowContribModal(value);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) =>
      onSelectChange(selectedRowKeys, selectedRows),
    onSelect: (record, selected, selectedRows) => {
      if (selected) {
        setSelectedOrganizations([record, ...selectedOrganizations]);
        onUpdateContributions(record);
        onShowContributeModal(true);
        setDisplaySelectedOrganisations(true);
      } else {
        onShowContributeModal(false);
        setDisplaySelectedOrganisations(false);

        let updSelection = [];
        if (selectedRows.length > 0) {
          updSelection = selectedOrganizations.filter(
            (c) => c.id !== record.id
          );
        } else {
          updSelection = [];
          setDisplaySelectedOrganisations(false);
        }

        //onUpdateContributions(record);
        // setSelectedOrganizations([...selectedOrganizations, updSelection]);
        // setSelectedOrganizations(updSelection);
        onRemoveContributions(record.id);
      }
    },
  };

  const onUpdateContributions = (selected) => {
    let previewContribution = {};
    if (selected) {
      if (selectedOrganizations.length === 0) {
        previewContribution = orgsContributions.find(
          (c) => c.id === selected.id
        );
      } else {
        previewContribution = selectedOrganizations.find(
          (c) => c.id === selected.id
        );
      }

      if (previewContribution) {
        setPreviewOrgsContrib(previewContribution);
      } else {
        setPreviewOrgsContrib(selected);
      }

      onShowContributeModal(true);
    }
  };

  const onRemoveContributions = (selectedId) => {
    let userSelectedContribs = [];
    let matchingContribs = [];

    if (selectedId > 0) {
      const itemsToKeep = selectedOrganizations.filter(
        (c) => c.id !== selectedId
      );

      itemsToKeep?.forEach((item) => {
        item?.contributions?.forEach((contribute) => {
          userSelectedContribs.push(contribute.label);
        });
      });

      userSelectedContribs?.forEach((contrib) => {
        const newContrib = contrib?.toString().toLowerCase();
        if (expectedContributions.includes(newContrib)) {
          matchingContribs.push(newContrib);
        }
      });

      if (!matchingContribs.includes("funding")) {
        return openNotification(
          "Cannot Remove Key Contribution",
          "At least one partner MUST have Funding contribution",
          Notify.ERROR
        );
      }
      if (!matchingContribs.includes("host organisation")) {
        return openNotification(
          "Cannot Remove Key Contribution",
          "At least one partner MUST have Host Organisation",
          Notify.ERROR
        );
      }
      if (matchingContribs.length < 2) {
        return openNotification(
          "Cannot Remove Key Contribution",
          "You MUST specifiy which partner(s) will provide Funding and Host contributions",
          Notify.ERROR
        );
      } else {
        const selectedRows = itemsToKeep.map((c) => c.id.toString());

        setSelectedRowKeys(selectedRows);
        setSelectedRows(itemsToKeep);
        onSelectedOrganization(itemsToKeep);
      }
    }
  };

  const onSelectedOrganization = (selectedPartners) => {
    // setSelectedOrganizations(selectedPartners);

    setSelectedOrganizations((prevSelection) => {
      // if organization does not have contributions then remove it altogether
      if (!prevSelection?.contributions && selectedPartners.length === 0) {
        return [];
      }

      // cater for invalid obejcts which are not array as expected
      if (!Array.isArray(prevSelection)) {
        return [selectedPartners];
      }

      // if user unselects or if orgs are empty then just retrun an empty object
      if (selectedPartners?.length === 0) {
        return [];
      }

      let orgIndex = 0;
      let Ids = [];

      if (Array.isArray(selectedPartners)) {
        // flatten tha array in order to ease saving to backend
        Ids = selectedPartners?.map((x) => x.id);
        orgIndex = prevSelection.findIndex((org) => Ids.includes(org.id));
      } else {
        orgIndex = prevSelection.findIndex(
          (org) => org.id === selectedPartners.id
        );
      }

      if (orgIndex === -1) {
        return [...prevSelection, selectedPartners];
      } else {
        // Update the existing organization contributions

        const updatedSelection = prevSelection.map((org, index) => {
          // Cases where the organization has not changed, only update floating info like otherContributions
          if (index === orgIndex) {
            org.otherContribution = selectedPartners.otherContribution;
            org.contributions = selectedPartners.contributions;
            return {
              ...org,
              contributions: selectedPartners.contributions,
            };
          }
          return org;
        });

        if (Ids.length > 0) {
          if (updatedSelection.length != selectedPartners.length) {
            return updatedSelection.filter((record) => Ids.includes(record.id));
          }
        }

        return updatedSelection;
      }
    });
  };

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
    setSelectedRows(selectedRows);
  };

  const onPopCancel = () => {
    onCancel();
    setDisabled(true);
    // form.resetFields();
  };

  const Confirm = () => {
    onCancel();
    form.resetFields();
  };

  const onHandleClick = () => {
    var sPartners = [];
    var updatedPartners = [];
    var contrib = [];

    selectedOrganizations.forEach((selected) => {
      var part = selectedOrganizations.find(
        (partner) => partner.id === selected.id
      );
      if (part === undefined) {
        contrib = selected.contributions.map((contr) => {
          return {
            key: parseInt(contr.key),
            value: contr.label,
          };
        });
        var d = {
          id: selected.id,
          address: `${selected.address?.province} (${selected.address?.cityOrTown})`,
          contributions: contrib,
          email: selected.email,
          name: selected.name,
          telephone: selected.telephone,
          type: {
            key: selected.typeid,
            value: selected.type,
          },
          otherContribution:
            selected.otherContribution === undefined
              ? null
              : selected.otherContribution,
        };

        var d = {
          id: selected.id,
          address: `${selected.address?.province} (${selected.address?.cityOrTown})`,
          contributions: contrib,
          email: selected.email,
          name: selected.name,
          telephone: selected.telephone,
          type: {
            key: selected.typeid,
            value: selected.type,
          },
          otherContribution:
            selected.otherContribution === undefined
              ? null
              : selected.otherContribution,
        };

        sPartners.push(d);
        updatedPartners.push(d);
      }
    });

    selectedOrganizations.forEach((selected) => {
      var part = sPartners.find((partner) => partner.id === selected.id);
      if (part === undefined) {
        contrib = selected?.contributions?.map((contr) => {
          return {
            key: parseInt(contr.key),
            value: contr.label,
          };
        });
        var d = {
          id: selected.id,
          address: selected.address,
          contributions: contrib,
          email: selected.email,
          name: selected.name,
          telephone: selected.telephone,
          type: {
            key: selected.typeid,
            value: selected.type,
          },
          otherContribution: selected.otherContribution,
        };
        updatedPartners.push(d);
      }
    });
    // setSelectedData([]);
    onModalSubmit(updatedPartners);
  };

  return (
    <Modal
      key="Update Partners"
      title="Update Partners"
      open={visible}
      closable={false}
      keyboard={false}
      maskClosable={false}
      onCancel={onCancelModal}
      width={1200}
      footer={[
        <div className="modal-footer-buttons">
          <Popconfirm
            key="2"
            title="Are you sure you want to cancel...you will lose all info entered?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => Confirm()}
            onCancel={onCancelModal}
            disabled={disabled}
          >
            <Button
              onMouseUp={() => onCancelModal()}
              style={{ marginLeft: 10 }}
            >
              Cancel
            </Button>
          </Popconfirm>
          <Button
            type="primary"
            // disabled={selectedRowKeys.length === 0 || !disableUpdate}
            onClick={onHandleClick}
          >
            Update
          </Button>
        </div>,
      ]}
    >
      <h2>
        <b>Selected Partner(s)</b>
      </h2>
      <SelectedOrganizations
        key={"orgs"}
        selectedOrgs={selectedOrganizations}
        onShowContributeModal={onUpdateContributions}
        onRemoveContr={onRemoveContributions}
      />
      <Row>
        <Col xs={20} md={20}>
          <Input
            placeholder="Search Partner"
            type="text"
            className="search-bar"
            onChange={handleSearchReset}
            onPaste={handleInputChange}
            onPressEnter={handleInputChange}
            value={searchText}
            allowClear
            size="large"
            prefix={<SearchOutlined />}
          />
        </Col>
        <Col xs={24} md={2}>
          <Button
            disabled={isNotSearchable}
            key="Search"
            value="Search"
            type="primary"
            onClick={handleSearchBtn}
            style={{ marginLeft: 10 }}
          >
            Search
          </Button>
        </Col>
      </Row>
      <div className="space"></div>
      {loading ? (
        <Skeleton active avatar />
      ) : (
        <div>
          <Form form={form} name={formName}>
            <Form.Item name="organization">
              <Table
                dataSource={filteredData}
                rowKey={(record) => record.key}
                hideSelectAllCheckbox={true}
                columns={columns}
                loading={loading}
                bordered
                rowSelection={rowSelection}
                pagination={{
                  disabled: pagingDisabled,
                  defaultCurrent: 1,
                  current: currentPage,
                  defaultPageSize: pageSize,
                  total: total,
                  pageSize: pageSize,
                  showQuickJumper: true,
                  onChange: onPageChange,
                  pageSizeOptions: [10, 20, 50, 100],
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} of ${total} ${
                      total > 1 ? "Organizations" : "Organization"
                    }`,
                }}
                size="middle"
              />
            </Form.Item>
          </Form>
        </div>
      )}

      <ContributeModal
        key={"edit-project-partner-modal"}
        onShow={onShowContributeModal}
        show={showContribModal}
        previewOrgsContrib={previewOrgsContrib}
        setOrgsContributions={handleSelectedContributions}
      />
    </Modal>
  );
};

export default EditProjectPartners;